import { Stack, Text, Title } from "@mantine/core";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import classes from "./AccountFrame.module.css";
import { ACCOUNT_TABS } from "./nav";
// Settings' pill tabs (design-system spec 3.7): one look for a page's tabs.
import tabs from "./SettingsTabs.module.css";

/**
 * The Account page's frame: live's header (`colortv-web/src/pages/account/`), the page's tabs as
 * links to their routes, so the URL is the open tab, and that tab's body in live's 640px column.
 * Each tab's screen renders inside it, as Settings' tabs do in `SettingsFrame`. It sits in
 * `platform/` so that any feature's tab can (spec web/account-tabs).
 */
export function AccountFrame({ teamId, children }: { teamId: string; children: ReactNode }) {
  return (
    <div className={classes.page}>
      <Stack gap={12} className={classes.header}>
        <Title order={2} className={classes.title}>
          Account
        </Title>
        <Text className={classes.description}>Your personal details and how you sign in.</Text>
      </Stack>
      <nav aria-label="Account" className={classes.tabs}>
        {ACCOUNT_TABS.map(({ label, icon: Icon, to }) => (
          // Exact: `/account` begins every tab's path, so a prefix match would light Profile on each.
          <Link
            key={to}
            to={to}
            params={{ teamId }}
            activeOptions={{ exact: true }}
            className={tabs.tab}
          >
            <Icon size={16} aria-hidden />
            {label}
          </Link>
        ))}
      </nav>
      <div className={classes.body}>{children}</div>
    </div>
  );
}
